<template>
  <div class="card shadow-sm mb-3">
    <div class="card-body">
      <h5 class="mb-3 font-weight-bold">HISTÓRICO ESTADO CADASTRAL</h5>

      <load v-if="loading" message="Carregando histórico..." />

      <div v-else class="table-responsive">
        <table class="table table-sm table-bordered table-hover bg-white mb-0">
          <thead>
            <tr>
              <th>CPF RF</th>
              <th>Nome RF</th>
              <th>Cód Familiar</th>
              <th>Data Criação</th>
              <th>Principal</th>
              <th>Estado Cadastral</th>
              <th>Data da Exclusão</th>
              <th>CadÚnico</th>
              <th class="text-center">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!historicos.length">
              <td colspan="8" class="text-center text-muted py-4">
                Nenhum histórico encontrado para o responsável familiar atual.
              </td>
            </tr>

            <tr v-for="item in historicos" :key="item.id">
              <td>{{ item.cpf_rf || "--" }}</td>
              <td>{{ item.nome_rf || "--" }}</td>
              <td>{{ item.codigo_familiar || "--" }}</td>
              <td>{{ item.data_criacao || "--" }}</td>
              <td>{{ item.principal }}</td>
              <td :class="statusClass(item.estado_cadastral_id)">
                <strong>{{ item.estado_cadastral_label || "--" }}</strong>
              </td>
              <td > 
                {{ Number(item.estado_cadastral_id) === 4 ? item.dt_ultima_atualizacao_usu : '' }}
              </td>
              <td>{{ item.cadunico }}</td>
              <td class="text-center">
                <b-link
                  v-if="item.familia_id && item.familia_id !== familyId"
                  target="_blank"
                  :to="'/dashboard/familias/edit/' + item.familia_id"
                  :title="$t('Ver Família')"
                  v-b-tooltip.hover
                >
                  <i class="fas fa-external-link-alt"></i>
                </b-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HistoricoEstadoCadastral",
  props: {
    familyId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      historicos: [],
    };
  },
  watch: {
    familyId: {
      immediate: true,
      handler() {
        this.buscarHistorico();
      },
    },
  },
  methods: {
    forceReload() {
      this.loadedFamilyId = null;
      this.buscarHistorico();
    },
    buscarHistorico() {
      if (!this.familyId) {
        this.historicos = [];
        return;
      }

      this.loading = true;

      axios
        .get(
          `api/dashboard/familias/${this.familyId}/historico-estado-cadastral`
        )
        .then((response) => {
          this.historicos = response.data.data || [];
        })
        .catch(() => {
          this.historicos = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    abrirFamilia(familiaId) {
      if (!familiaId) {
        return;
      }

      if (parseInt(familiaId) === parseInt(this.familyId)) {
        return;
      }

      this.$router.push(`/dashboard/familias/edit/${familiaId}`);
    },
    statusClass(statusId) {
      switch (parseInt(statusId)) {
        case 3:
          return "text-success";
        case 4:
          return "text-danger";
        case 2:
          return "text-warning";
        default:
          return "text-primary";
      }
    },
  },
};
</script>
